import { Box, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { CashflowCategory } from '../../models/cashflows/cashflow';
import CategoryBreakdownChart from './category-breakdown-chart';

interface DashboardBreakdownsProps {
  categories?: CashflowCategory[];
  isLoading: boolean;
  onCategoryClick: (
    category: CashflowCategory,
    type: 'expenses' | 'revenue'
  ) => void;
}

const DashboardBreakdowns = ({
  categories,
  isLoading,
  onCategoryClick,
}: DashboardBreakdownsProps) => {
  const { t } = useTranslation();

  return (
    <Grid
      container
      spacing={3}
      sx={{
        alignItems: 'stretch',
        mb: 3,
      }}
    >
      <Grid
        size={{
          xs: 12,
          lg: 6,
        }}
      >
        <Box sx={{ height: '100%' }}>
          <CategoryBreakdownChart
            type="revenue"
            categories={categories}
            title={t('INCOME_BY_CATEGORY')}
            isLoading={isLoading}
            onCategoryClick={(cat) => onCategoryClick(cat, 'revenue')}
          />
        </Box>
      </Grid>
      <Grid
        size={{
          xs: 12,
          lg: 6,
        }}
      >
        <Box sx={{ height: '100%' }}>
          <CategoryBreakdownChart
            type="expenses"
            categories={categories}
            title={t('EXPENSES_BY_CATEGORY')}
            isLoading={isLoading}
            onCategoryClick={(cat) => onCategoryClick(cat, 'expenses')}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default DashboardBreakdowns;
